<template>

    <div class="surface-section px-4 py-5 md:px-6 lg:px-8">
        <div
            class="flex md:align-items-center md:justify-content-between flex-column md:flex-row pb-4 border-bottom-1 surface-border">
        </div>
    </div>

    <div class="surface-section px-4 py-6 md:px-6 lg:px-8 text-center">
        <img src="images/blocks/logos/kitrin-logo-black-revised-rev1.png" alt="Image" height="70">
        <div class="font-medium text-900 mt-4 mb-3">&copy; 2026 Kitrin (UK) Limited</div>
        <p class="text-600 line-height-3 mt-0 mb-4">
            The IsoEvolve software from Kitrin is for healthcare professionals, financial advisers, and service professionals.
            <br><br>
            Our software makes it simple for our clients to run their businesses, which helps them save time and
            money and perform their jobs more effectively.
        </p>
        <div class="flex align-items-center justify-content-center">
            <a class="cursor-pointer text-700 mr-5">
                <i class="pi pi-twitter"></i>
            </a>
            <a class="cursor-pointer text-700 mr-5">
                <i class="pi pi-facebook"></i>
            </a>
            <a class="cursor-pointer text-700 mr-5">
                <i class="pi pi-instagram"></i>
            </a>
            <a class="cursor-pointer text-700">
                <i class="pi pi-linkedin"></i>
            </a>
        </div>
    </div>

</template>

<script>
export default {
    methods: {}
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
